import RichTextElement from './RichTextElement';
import RichTextElementDefinition from './RichTextElementDefinition';
import RichTextElementMetaData from './RichTextElementMetaData';

export default {
  RichTextElement: RichTextElement,
  RichTextElementDefinition: RichTextElementDefinition,
  RichTextElementType: RichTextElementMetaData.type
};
